// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.google-sign-in-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 10px;
  background-color: #ffffff;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: box-shadow 0.2s ease-in-out, transform 0.2s ease-in-out;
}

.google-sign-in-button:hover {
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
}

.google-sign-in-button:active {
  transform: translateY(1px);
}

.google-icon {
  width: 24px;
  height: 24px;
  margin-right: 10px;
}

.text-dark {
  color: #333333;
}

.font-semibold {
  font-weight: 600;
}

.flex {
  display: flex;
}

.items-center {
  align-items: center;
}

.justify-center {
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/GoogleSignInButton.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,mEAAmE;AACrE;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":[".google-sign-in-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  padding: 10px;\n  background-color: #ffffff;\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n  font-size: 16px;\n  cursor: pointer;\n  transition: box-shadow 0.2s ease-in-out, transform 0.2s ease-in-out;\n}\n\n.google-sign-in-button:hover {\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.google-sign-in-button:active {\n  transform: translateY(1px);\n}\n\n.google-icon {\n  width: 24px;\n  height: 24px;\n  margin-right: 10px;\n}\n\n.text-dark {\n  color: #333333;\n}\n\n.font-semibold {\n  font-weight: 600;\n}\n\n.flex {\n  display: flex;\n}\n\n.items-center {\n  align-items: center;\n}\n\n.justify-center {\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
